import { render } from "./statusLabel.vue?vue&type=template&id=5e4df462&scoped=true"
import script from "./statusLabel.vue?vue&type=script&lang=js"
export * from "./statusLabel.vue?vue&type=script&lang=js"

import "./statusLabel.vue?vue&type=style&index=0&id=5e4df462&lang=scss&scoped=true"
import "./statusLabel.vue?vue&type=style&index=1&id=5e4df462&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4df462"]])

export default __exports__